export default () => {
  const timelineMoreBtn = document.querySelector('.timeline-more button'),
        items = document.querySelectorAll('.timeline-item');

  if(!timelineMoreBtn) return;

  timelineMoreBtn?.addEventListener('click', () => {
    items.forEach(item => {
      item.classList.remove('d-none');
      timelineMoreBtn.parentNode.remove();
    });

    items[items.length - 1].classList.add('d-flex');
    timelineScrollFunction();
  });

  window.addEventListener('scroll', () => {
    timelineScrollFunction();
  });

  document.addEventListener('DOMContentLoaded', () => {
    timelineScrollFunction();
  });

  const timelineScrollFunction = function(){
    let item = document.querySelector('.timeline');

    if(!item) return;

    let scrollTop =  item.scrollTop;
    let windowHeight = window.outerHeight;
    let windowWidth = window.outerWidth;
    let windowHeightHalf = windowHeight / 2;
    
    const rect = item.getBoundingClientRect();
    const elHeight = rect.height;
    const finalHeight =  -(rect.top - scrollTop);
    
    if(finalHeight <= elHeight) {
      item.querySelector('.timeline-line-fill').style.height = `${finalHeight + 300}px`;
    }

    document.querySelectorAll('.timeline-item').forEach((item, i) =>{
      const rect = item.getBoundingClientRect();

      let gt;

      if(windowWidth > 1200){
        gt = (scrollTop + windowHeightHalf) - 110;
      }else{
        gt = (scrollTop + windowHeightHalf) - 10
      }

      if(i && (rect.top >= gt)) {
        item.classList.remove('active');
      } else {
        item.classList.add('active');
      }
    });
  }

}